import { atom, useAtom } from "jotai";
import { useFullScreenHandle } from "react-full-screen";

const fullscreenActiveAtom = atom(false);

export const useFullScreen = () => {
  const fullscreenHandle = useFullScreenHandle();
  const [fullscreenActive, setFullscreenActive] = useAtom(fullscreenActiveAtom);

  const enter = async () => {
    await fullscreenHandle.enter();
    setFullscreenActive(true);
  };

  const exit = async () => {
    await fullscreenHandle.exit();
    setFullscreenActive(false);
  };

  return {
    active: fullscreenActive,
    handle: {
      ...fullscreenHandle,
      enter,
      exit,
    },
  };
};
